import _ from 'lodash';
import React, { Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { Link } from 'react-router-dom';

import { wrapGrid } from 'client/shared/util';
import { MusicLibrary } from 'client/shared/components';

import Header from './header';
import autobind from 'autobind-decorator';
import SongOptions from '../my-music/song-options';
import artistStore from '../../../shared/stores/artist-store';

const Tracks = wrapGrid((props) => ( <MusicLibrary trackListMode { ...props } /> ));


@inject('songsStore')
class SongRow
extends React.Component {
	render () {
		const { songsStore, song, index } = this.props;

		if (_.isEmpty(song)) {

			return null;
		}

		return (
			<div className="grid-x align-justify align-middle song-row margin-vertical-1" style={{fontSize: '1.25rem'}} onClick={this.onPlayClick}>
				{/* <div className="cell shrink">
					<div className="song-row-counter" data-full-preview-position={ song.fullPreviewPosition }>
						<span className="icon far fa-play-circle" onClick={ this.onPlayClick }></span>
					</div>
				</div>
				<div className="cell small-7">
					<div className="inline"> { `${song.title}` } </div>
				</div>

				<div className="cell small-3">
					<h5>{ song.duration }</h5>
				</div>
				<div className="cell small-1 text-center">
					{ this.renderUserOpts() }
				</div> */}
				
			</div>
		);
	}

	@autobind
	onPlayClick () {
		const { song, songsStore } = this.props;
		songsStore.setCurrentSong(song.id);
	}

	renderUserOpts () {
		const { song} = this.props;
		// const song = songsStore.getSongByID(songID);
		return (
			<Fragment>
				<SongOptions
					songID={ song.id }
					song={ song }
					optionsTheme={ 'light' }
				/>
			</Fragment>
		)
	}
}

@inject('artistStore', 'userStore', 'albumsStore', 'songsStore')
@observer
export default class Artist
extends React.Component {
	componentDidMount () {
		const { albumsStore, songsStore } = this.props;

		artistStore.fetchIfEmpty();
		albumsStore.fetchIfEmpty();
		songsStore.fetchIfEmpty();
	}

	render() {
		const {
			artistStore,
			userStore,
			albumsStore,
			songsStore,
			match: {
				params: { id, artistID }
			}
		} = this.props;

		const album = albumsStore.items.find(a=>a._id === id);
		// const album = albumsStore.getItemByID({ id });

		if (
			artistStore.isLoading ||
			userStore.isLoading ||
			albumsStore.isLoading ||
			songsStore.isLoading ||
			_.isEmpty(album)
		) {

			return null;
		}

		return (
			<Fragment>
				<Link to={{pathname:"/artist/:id/albums".replace(':id', album.artistID)}}>
					<div className="back-link margin-left-3" style={{alignItems:"center"}}>
						<i className="fas fa-angle-left margin-right-1"/>Back to Albums
					</div>
				</Link>

				<div className="grid-x header-grid margin-bottom-3">
					<div className="cell small-12">
						<Header album={ album } />
					</div>
				</div>
				<div style={{paddingLeft:'2vw'}}>
					<Tracks
						artist={ album.artist }
						songList={ album.songs }
					/>
				</div>
					{/* <div className="cell small-7" style={{marginLeft: '3vw'}}>
						<div className="section-title heading artist">Title</div>
					</div>

					<div className="cell small-3">
						<div className="section-title heading artist">Duration</div>
					</div>
					<div className="cell small-1">
						<div className="cell">&nbsp;</div>
					</div> */}

				<div className="grid-x primary-font">
					<div className="cell small-12">
						{
							album.songs.map((song, index) => {
								return (
									<SongRow key={ `${song.id}-${index}` } song={ song } index={ index + 1 } />
								);
							})
						}
					</div>
				</div>
			</Fragment>
		);
	}

	
}
